const startPage: Record<string, Record<string, string> | string> = {
    logoAlt: 'Инконсалт K',
};

export default startPage;
